import { render } from "./SidebarMenuButton.vue?vue&type=template&id=97a47858&ts=true"
import script from "./SidebarMenuButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97a47858"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97a47858', __exports__)) {
    api.reload('97a47858', __exports__)
  }
  
  module.hot.accept("./SidebarMenuButton.vue?vue&type=template&id=97a47858&ts=true", () => {
    api.rerender('97a47858', render)
  })

}


export default __exports__